export default import.meta.ROLLDOWN_FILE_URL_LphhLScmzwPqWwTyAbd7ig